import React from 'react';
import _ from 'underscore';
import './NanoMajorCard.scss';

const NanoMajorCard = (props) => {
  const { externalLink, tracks, track_long_symbol } = props;
  const track = _.find(tracks, track => track.long_symbol === track_long_symbol);

  if (!track) { return null; }

  return (
    <a href={`/programs/${track.long_symbol}`} target={externalLink ? '_blank' : ''} className='nm-card col-12 col-sm-10 col-md-6 col-lg-4 mb-5 text-decoration-none'>
      <div className="bg-white rounded hovercraft overflowHidden h-100 d-flex flex-column">
        <div className='header d-flex flex-column p-3 p-sm-4' style={{ backgroundColor: track.color }}>
          <div className="d-flex justify-content-end">
            <div>
              {track_long_symbol == 'fsdsai' && (<span className="nmAttr rounded mr-2 d-md-none" style={{color: "#1647fb"}}>Most Popular</span>)}
              <span className='nmAttr rounded'>{track.num_of_courses} Courses</span>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-end">
            <div className='logo d-flex flex-column rounded align-items-center'>
              <h1 className='shortSymbol'>{track.short_name}</h1>
            </div>

            <div className='nmCourses d-flex flex-wrap justify-content-end'>
              {
                track.tags.map((tag, index) => (<div key={index}><span className="rounded">{tag}</span></div>))
              }
            </div>
          </div>
        </div>

        <div className="p-3 p-sm-4 flex-grow-1 d-flex flex-column">
          <h2 className="mb-2 mb-sm-3">
            <span className='dot rounded-circle d-inline-block' style={{backgroundColor: track.color}}></span>
            <span style={{fontSize: '90%'}}>{track.long_name}</span>
          </h2>
          <p className="explanation serif flex-grow-1 mb-3"><span style={{fontSize: '95%'}}>{track.description}</span></p>
          <p className='py-1 mb-0 text-secondary text-center view'><b>VIEW DETAILS</b></p>
        </div>
      </div>

      {track_long_symbol == 'fsdsai' && (<h3 className="text-center mt-3 d-none d-md-block"><span className="badge badge-success px-3 py-2 rounded" style={{backgroundColor: "#1647fb"}}>Most Popular</span></h3>)}
    </a>
  );
}

export default NanoMajorCard;
